<template>
  <TableLayout :permissions="['business:workorderlog:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="主键" prop="id">
          <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建人编码" prop="creator">
          <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
        </el-form-item>
        <el-form-item label="更新人编码" prop="editor">
          <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="editDate">
          <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
        </el-form-item>
        <el-form-item label="是否删除0否 1是" prop="isdeleted">
          <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="工单编码（关联workorder)" prop="workorderId">
          <el-input v-model="searchForm.workorderId" placeholder="请输入工单编码（关联workorder)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="searchForm.title" placeholder="请输入标题" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="content">
          <el-input v-model="searchForm.content" placeholder="请输入简介" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="操作类型 0任务上报 1任务确认 2任务分配物业主管 3任务关闭 4任务分配处理人 5任务催促" prop="objType">
          <el-input v-model="searchForm.objType" placeholder="请输入操作类型 0任务上报 1任务确认 2任务分配物业主管 3任务关闭 4任务分配处理人 5任务催促" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联对象编码" prop="objId">
          <el-input v-model="searchForm.objId" placeholder="请输入关联对象编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="操作前内容" prop="beforeContent">
          <el-input v-model="searchForm.beforeContent" placeholder="请输入操作前内容" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="操作后内容" prop="afterContent">
          <el-input v-model="searchForm.afterContent" placeholder="请输入操作后内容" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="参数1" prop="param1">
          <el-input v-model="searchForm.param1" placeholder="请输入参数1" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="参数2" prop="param2">
          <el-input v-model="searchForm.param2" placeholder="请输入参数2" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="参数3" prop="param3">
          <el-input v-model="searchForm.param3" placeholder="请输入参数3" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="参数4" prop="param4">
          <el-input v-model="searchForm.param4" placeholder="请输入参数4" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:workorderlog:create', 'business:workorderlog:delete']">
        <li><el-button type="primary" @click="$refs.operaWorkorderLogWindow.open('新建工单操作历史表')" icon="el-icon-plus" v-permissions="['business:workorderlog:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:workorderlog:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="workorderId" label="工单编码（关联workorder)" min-width="100px"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="100px"></el-table-column>
        <el-table-column prop="content" label="简介" min-width="100px"></el-table-column>
        <el-table-column prop="objType" label="操作类型 0任务上报 1任务确认 2任务分配物业主管 3任务关闭 4任务分配处理人 5任务催促" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="关联对象编码" min-width="100px"></el-table-column>
        <el-table-column prop="beforeContent" label="操作前内容" min-width="100px"></el-table-column>
        <el-table-column prop="afterContent" label="操作后内容" min-width="100px"></el-table-column>
        <el-table-column prop="param1" label="参数1" min-width="100px"></el-table-column>
        <el-table-column prop="param2" label="参数2" min-width="100px"></el-table-column>
        <el-table-column prop="param3" label="参数3" min-width="100px"></el-table-column>
        <el-table-column prop="param4" label="参数4" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:workorderlog:update', 'business:workorderlog:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaWorkorderLogWindow.open('编辑工单操作历史表', row)" icon="el-icon-edit" v-permissions="['business:workorderlog:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:workorderlog:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaWorkorderLogWindow ref="operaWorkorderLogWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaWorkorderLogWindow from '@/components/business/OperaWorkorderLogWindow'
export default {
  name: 'WorkorderLog',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaWorkorderLogWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        workorderId: '',
        title: '',
        content: '',
        objType: '',
        objId: '',
        beforeContent: '',
        afterContent: '',
        param1: '',
        param2: '',
        param3: '',
        param4: ''
      }
    }
  },
  created () {
    this.config({
      module: '工单操作历史表',
      api: '/business/workorderLog',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
